/**
 * Criteria screening-stage mapping from the loaded detail payload.
 */

import type { CriteriaScreeningResponse } from "../../../../data-model/eligibilityDetail";
import { useEligibilityDetailContext } from "../../EligibilityDetailContext";
import { EvaluationStageTab } from "../EvaluationStageTab";

/**
 * Render criteria questions and nested atoms from the criteria-detail response.
 *
 * @returns Data-driven criteria-stage mapping
 */
const CriteriaEvaluationTab = ({
  criteriaDetail,
}: {
  criteriaDetail: CriteriaScreeningResponse | null;
}) => {
  const { detail } = useEligibilityDetailContext();
  if (!criteriaDetail) {
    return null;
  }

  const stage = criteriaDetail.result?.stages?.find(
    (item) => item.stage === "criteria",
  );
  return (
    <EvaluationStageTab
      heading="Criteria Evaluation"
      stage={stage}
      overrides={criteriaDetail.overrides ?? detail.overrides}
    />
  );
};

export default CriteriaEvaluationTab;
